import {createRouter, createWebHashHistory, RouteRecordRaw} from 'vue-router'
import Home from '@/components/views/Home.vue'
import Register from '@/components/views/Register.vue'
import Login from '@/components/views/Login.vue'
import ResetPw from '@/components/views/ResetPw.vue'
import ResetPwResetToken from '@/components/views/ResetPwResetToken.vue'
import Profile from '@/components/views/Profile.vue'
import Form from '@/components/views/Form.vue'
import store from '@/store'
import ExpertValidation from "@/components/views/ExpertValidation.vue";


const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        redirect: Home
    },
    {
        path: '/home',
        name: 'Home',
        component: Home
    },
    {
        path: '/register',
        name: 'Register',
        component: Register
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/resetpw',
        name: 'ResetPw',
        component: ResetPw
    },
    {
        path: '/resetpwtoken',
        name: 'ResetPwResetToken',
        component: ResetPwResetToken
    },
    {
        path: '/profile',
        name: 'Profile',
        component: Profile
    },
    {
        path: '/form',
        name: 'Form',
        component: Form
    },
    {
        path: '/validate',
        name: 'ExpertValidation',
        component: ExpertValidation
    }
]

const router = createRouter({
    history: createWebHashHistory(), // see also: https://next.router.vuejs.org/guide/essentials/history-mode.html#netlify
    routes
})

router.beforeEach((to, from, next) => {
    if(store.state.token.length === 0 && to.name !== 'Register' && to.name !== 'ResetPw' && to.name !== 'ResetPwResetToken') {
        store.dispatch('logout')
        next()
    } else if(to.name === 'Login') {
        next({ name: 'Home' })
    } else {
        next()
    }
})

export default router
